import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isStaff } from "@/lib/permissions";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        toast.success(`Welcome, ${res.data.name || res.data.email}!`);
        navigate(isStaff(res.data.role) ? "/admin" : "/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#f8faf8]">
      <div className="text-center">
        <Loader2 className="h-9 w-9 animate-spin text-emerald-700 mx-auto" />
        <p className="mt-4 text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
